import { createSelector } from 'reselect';
import { slidersSelector } from './root';
import { selectedCitySelector } from './cities';

export const filteredSlidersSelector = createSelector(
  slidersSelector,
  selectedCitySelector,
  (sliders, city) => {
    if (!city) return sliders;
    return sliders.filter((slider) => {
      if (!slider.cities || slider.cities === '') return true;
      const cityIds = slider.cities.split(',');
      return cityIds.includes(String(city.id));
    });
  },
);
